import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import TrackChangesOutlinedIcon from "@mui/icons-material/TrackChangesOutlined";

export default function VisionMission() {
  return (
    // <Box
    //   sx={{
    //     py: { xs: 12, md: 18 },
    //     backgroundColor: "var(--color-primary-dark)",
    //     position: "relative",
    //     overflow: "hidden",
    //   }}
    // >
    <Box
      sx={{
        py: { xs: 3, md: 6 },
        backgroundColor: "var(--color-bg)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            gap: { xs: 5, md: 8 },
          }}
        >
          {/* MISSION CARD */}
          <motion.div
            whileHover={{ y: -4 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
          >
            <Box
              sx={{
                height: "100%",
                p: { xs: 4, md: 6 },
                borderRadius: 4,
                background: "var(--color-gold)",
                border: "1px solid var(--color-gold)",
                // boxShadow: "0 35px 80px rgba(0,0,0,0.28)",
                transition: "all 0.4s ease",

                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: "0 45px 100px rgba(0,0,0,0.35)",
                },
              }}
            >
              {/* <Box
              sx={{
                height: "100%",
                p: { xs: 4, md: 6 },
                borderRadius: 4,
                background: `
                  linear-gradient(
                    180deg,
                    rgba(33,33,33,0.96),
                    rgba(33,33,33,0.86)
                  )
                `,
                border: "1px solid rgba(207,172,106,0.22)",
                boxShadow: "0 40px 90px rgba(0,0,0,0.7)",
                transition: "all 0.45s ease",

                "&:hover": {
                  boxShadow:
                    "0 55px 120px rgba(0,0,0,0.85), 0 0 0 1px rgba(207,172,106,0.45)",
                  background: `
                    linear-gradient(
                      180deg,
                      rgba(33,33,33,0.98),
                      rgba(33,33,33,0.9)
                    )
                  `,
                },
              }}
            > */}
              {/* ICON */}
              <Box
                sx={{
                  width: 56,
                  height: 56,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(255,255,255,0.25)",

                  mb: 3,
                  transition: "all 0.45s ease",

                  ".MuiSvgIcon-root": {
                    transition: "all 0.45s ease",
                  },

                  "&:hover .MuiSvgIcon-root": {
                    transform: "rotate(-8deg) scale(1.08)",
                  },
                }}
              >
                <TrackChangesOutlinedIcon
                  sx={{ color: "var(--color-primary-dark)", fontSize: 28 }}
                />
              </Box>

              {/* TITLE */}
              <Typography
                sx={{
                  fontSize: { xs: "1.5rem", md: "1.8rem" },
                  fontWeight: 600,
                  color: "var(--color-primary-dark)",

                  // color: "var(--color-gold)",
                  mb: 2,
                }}
              >
                Our Mission
              </Typography>

              {/* TEXT */}
              <Typography
                sx={{
                  fontSize: { xs: 14, md: 16 },
                  lineHeight: 1.9,
                  // color: "rgba(255,255,255,0.8)",
                  color: "rgba(28,28,28,0.85)",
                }}
              >
                To create a results-driven, ethical, and refined real estate
                experience — delivering superior service, personalized
                solutions, and long-term value for every client we serve.
              </Typography>
            </Box>
          </motion.div>

          {/* VISION CARD */}
          <motion.div
            whileHover={{ y: -4 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
          >
            <Box
              sx={{
                height: "100%",
                p: { xs: 4, md: 6 },
                borderRadius: 4,
                background: "var(--color-white)",
                border: "1px solid rgba(0,0,0,0.08)",
                // boxShadow: "0 25px 60px rgba(0,0,0,0.18)",
                transition: "all 0.4s ease",

                "&:hover": {
                  transform: "translateY(-6px)",
                  borderColor: "var(--color-gold)",
                  boxShadow: "0 35px 80px rgba(0,0,0,0.25)",
                },
              }}
            >
              {/* <Box
              sx={{
                height: "100%",
                p: { xs: 4, md: 6 },
                borderRadius: 4,
                background: `
                  linear-gradient(
                    180deg,
                    rgba(33,33,33,0.96),
                    rgba(33,33,33,0.86)
                  )
                `,
                border: "1px solid rgba(207,172,106,0.22)",
                boxShadow: "0 40px 90px rgba(0,0,0,0.7)",
                transition: "all 0.45s ease",

                "&:hover": {
                  boxShadow:
                    "0 55px 120px rgba(0,0,0,0.85), 0 0 0 1px rgba(207,172,106,0.45)",
                },
              }}
            > */}
              {/* ICON */}
              <Box
                sx={{
                  width: 56,
                  height: 56,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(207,172,106,0.15)",

                  // backgroundColor: "rgba(207,172,106,0.12)",
                  mb: 3,
                  transition: "all 0.45s ease",

                  "&:hover": {
                    backgroundColor: "rgba(207,172,106,0.18)",
                  },
                }}
              >
                <VisibilityOutlinedIcon
                  sx={{
                    color: "var(--color-gold)",
                    fontSize: 28,
                    transition: "transform 0.45s ease",
                  }}
                />
              </Box>

              {/* TITLE */}
              <Typography
                sx={{
                  fontSize: { xs: "1.5rem", md: "1.8rem" },
                  fontWeight: 600,
                  // color: "var(--color-gold)",
                  color: "var(--color-text-primary)",

                  mb: 2,
                }}
              >
                Our Vision
              </Typography>

              {/* TEXT */}
              <Typography
                sx={{
                  fontSize: { xs: 14, md: 16 },
                  lineHeight: 1.9,
                  // color: "rgba(255,255,255,0.8)",
                  color: "var(--color-text-muted)",
                }}
              >
                To be the most trusted luxury real estate partner in the UAE —
                empowering owners, tenants, and investors through integrity,
                professionalism, and deep market insight.
              </Typography>
            </Box>
          </motion.div>
        </Box>
      </Container>
      {/* BOTTOM GOLD LINE */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: "5%",
          right: "5%",
          height: "1px",
          background:
            "linear-gradient(90deg, transparent, var(--color-gold), transparent)",
          opacity: 0.6,
        }}
      />
    </Box>
  );
}
